import { render, staticRenderFns } from "./combo.vue?vue&type=template&id=4f88bf27&scoped=true&"
import script from "./combo.vue?vue&type=script&lang=js&"
export * from "./combo.vue?vue&type=script&lang=js&"
import style0 from "./combo.vue?vue&type=style&index=0&id=4f88bf27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f88bf27",
  null
  
)

export default component.exports